import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Nunca entendí por qué mi hijo era tan intenso emocionalmente. Con el Tomo 3 entendí todo en una tarde. Lloré de alivio. Por fin tenía palabras para lo que veía en él.',
    author: 'Mariana G.',
    details: 'Mamá de Tomás, 6 años · Buenos Aires',
    photo: 'https://randomuser.me/api/portraits/women/44.jpg'
  }, {
    quote: 'Pensé que era un producto más de crianza. Resultó ser lo más útil y concreto que leí en 4 años de ser mamá. Lo recomiendo sin dudarlo.',
    author: 'Carolina V.',
    details: 'Mamá de Sofía y Lucía · Bogotá',
    photo: 'https://randomuser.me/api/portraits/women/68.jpg'
  }, {
    quote: 'El Diccionario de Conductas me salvó la semana. Lo tengo guardado en el teléfono y lo abro cada vez que no sé qué hacer. Es como tener una guía de respuestas al instante.',
    author: 'Valentina R.',
    details: 'Mamá de Mateo, 4 años · Ciudad de México',
    photo: 'https://randomuser.me/api/portraits/women/65.jpg'
  }];
  return <section className="py-10 px-4 bg-cream-100 relative" data-id="element-186">
      {/* Subtle pink tint overlay */}
      <div className="absolute inset-0 bg-dusty-rose-50/50 mix-blend-multiply" data-id="element-187"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-188">
        <FadeIn data-id="element-189">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-burgundy-900 mb-10" data-id="element-190">
            Lo que dicen las mamás que ya tienen su colección
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-191">
          {testimonials.map((testimonial, idx) => <FadeIn key={idx} delay={idx * 0.15} direction="up" data-id="element-192">
              <div className="bg-white rounded-2xl p-8 shadow-md border border-cream-200 h-full flex flex-col relative" data-id="element-193">
                <Quote className="absolute top-6 right-6 w-10 h-10 text-dusty-rose-200 opacity-50" data-id="element-194" />

                {/* Real photo avatar */}
                <div className="w-16 h-16 rounded-full mb-6 overflow-hidden border-2 border-dusty-rose-200 shadow-sm flex-shrink-0" data-id="element-195">
                  <img src={testimonial.photo} alt={testimonial.author} className="w-full h-full object-cover" data-id="element-196" />
                </div>

                <p className="font-heading italic text-lg text-burgundy-800 mb-8 flex-grow leading-relaxed" data-id="element-197">
                  "{testimonial.quote}"
                </p>

                <div className="mt-auto pt-6 border-t border-cream-100" data-id="element-198">
                  <p className="font-bold text-burgundy-900" data-id="element-199">
                    {testimonial.author}
                  </p>
                  <p className="text-sm text-burgundy-600 mt-1" data-id="element-200">
                    {testimonial.details}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}